export default (() => {
	$(window).on('load', function () {
		$('.preload-indicator').fadeOut();
		$('.preloader')
			.delay(50)
			.fadeOut('slow');
		$('body').removeClass('no-scroll');
	});
})();
